// Every word Recordings and dates and Webinars show (AdminRecordings.dc.html, AdminWebinars.dc.html),
// in Adam's writing rules. A line marked "undrawn" is on no board and goes in the stage 5 batch for
// Adam; a line marked "changed" differs from its board for the reason beside it. Pure: no imports.

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`
const cap = s => (s ? s[0].toUpperCase() + s.slice(1) : s)

export const COPY = {
  // the page head, on all 3 tabs
  eyebrow: 'Recordings stay on Vimeo',
  title: 'Recordings and dates',
  tabsLabel: 'Recordings and dates',
  tabs: { recordings: 'Recordings', dates: 'Cohorts and dates', webinars: 'Webinars' },
  strip: "Nothing is uploaded here. Every recording stays on Vimeo and plays inside the hub through Vimeo's own player. Paste the link or the embed code, and the hub takes the title and length from Vimeo.",

  // the recordings list
  listLabel: 'Recordings by product',
  chips: { live: 'Live', tonight: 'Tonight', after: 'After the session', draft: 'Draft' },
  noRecordings: 'There are no recordings or sessions in the hub yet. They show here once a product has its weeks or modules.', // undrawn
  readOnlyRecordings: 'Only an owner, admin or support can change a recording.', // undrawn
  partName: (label, part) => `${label}, part ${part}`, // undrawn: Property Cashflow For Life's 3A, 3B, 3C
  // undrawn (the product-types plan, 13 Oct): a masterclass's video still to add, and the button that adds a
  // new on-demand course's next module
  videoSub: 'Its video',
  addModule: n => `Add module ${n}`,
  moduleAdded: label => `${label} added. Add its recording when it's ready.`,
  // undrawn (Adam, 13 Oct): a row's mark for a recording with its own thumbnail, and the question when
  // another row is picked before the 1 open is saved
  hasThumbnail: 'Has a thumbnail',
  unsavedTitle: "Your changes aren't saved",
  unsavedBody: (now, next) => `You haven't saved your changes to ${now}. If you open ${next} now, they're lost.`,
  keepEditing: 'Keep editing',
  openWithoutSaving: 'Open without saving',

  // the editor
  link: 'Vimeo link or embed code',
  linkPlaceholder: 'https://vimeo.com/...',
  linkEmpty: 'Paste the link or embed code from Vimeo. The video stays on Vimeo.',
  linkFound: id => `Vimeo video ${id} found. On save the hub reads its title and length from Vimeo, and it plays from there.`,
  linkBad: "That isn't a Vimeo link yet. Paste the address or the embed code from Vimeo.",
  length: 'Length', // undrawn: the typed fallback BUILD-PLAN stage 6 allows when Vimeo can't be read
  lengthPlaceholder: '1:49:22',
  lengthHint: "Vimeo didn't give its length, so type it, like 1:49:22.", // undrawn
  lengthBad: 'Type the length as hours, minutes and seconds, like 1:49:22.', // undrawn
  chapters: 'Chapters, 1 a line',
  chaptersPlaceholder: '03:48 The check-in',
  preview: 'What members will see',
  noChapters: 'Type a time then a title on each line, like 1:15:06 Part 4.',
  // changed: "1 chapter", not the board's "1 chapters"
  chapterCount: (n, bad) => (n === 0 ? '' : plural(n, 'chapter') + (bad ? `, ${bad} without a time` : '')),
  summary: 'Summary',
  summaryPlaceholder: 'What this session covered, in a paragraph',
  keyMessages: 'Key messages, 1 a line', // undrawn: design 5.5 and Add a product's "summary and key messages"
  keyMessagesPlaceholder: 'The heading first, then a sentence or 2 under it', // undrawn
  keyMessagesHint: 'Each line is 1 of the things to take away. Its first sentence shows in bold.', // undrawn
  homework: 'Homework, 1 a line',
  homeworkPlaceholder: 'Each line becomes a tick box',
  homeworkTooLong: 'A homework line can be up to 500 characters. Split the long one into 2.', // undrawn
  files: 'Files',
  addFile: 'Add a worksheet or pack',
  filesAttached: n => `${plural(n, 'file')} attached. Add another`,
  filesOwnerAdmin: n => (n ? `${plural(n, 'file')} attached.` : 'No files attached.'), // undrawn: support sees the count only
  fileAdding: name => `Adding ${name}.`, // undrawn
  fileAdded: (title, name) => `Added ${title} to ${name}.`, // undrawn
  fileNoSection: product => `Add a section to ${product} in Resources and files first, then add the file here.`, // undrawn
  tags: 'Tags',
  tagsPlaceholder: 'e.g. delayed completion, refurb costs',
  switchOn: 'Switch it on',
  itsLive: "It's live",
  saveChanges: 'Save changes', // undrawn: a live recording's edits (the board has only Switch it on)
  // undrawn: switching a live recording off, owner and admin (Adam, 5 Oct, question 5)
  switchOff: 'Switch it off',
  confirmOff: name => `Switch off ${name}? Members stop seeing it straight away. Their progress is kept.`,
  keepItOn: 'Keep it on',
  switchedOff: "Switched off. Members don't see it until you switch it on again.",
  // changed: the board's "has been emailed" goes, as the hub sends no new-recording email (Adam, 5 Oct,
  // stage 6); the bell is what members see, written by the database as it goes live. The bell is
  // claimed only when the database said it would ring (hub.bell_will_ring, Adam, 5 Oct, stage 6's
  // batch): not for 1 that's been live before, or a product that doesn't speak yet
  liveNow: audience => `Live. ${cap(audience)} can watch it now, and it's in their bell.`,
  liveNoBell: audience => `Live. ${cap(audience)} can watch it now.`, // undrawn
  savedLive: 'Saved. Members see the change now.',
  savedDraft: "Saved. Members don't see it until you switch it on.", // undrawn
  needLink: 'Paste the Vimeo link first.',
  needLength: 'Type its length first, like 1:49:22.', // undrawn
  chaptersNeedTimes: 'Give every chapter a time first, like 1:15:06 Part 4.', // undrawn
  chaptersSameTime: stamp => `2 chapters start at ${stamp}. Give each its own time.`, // undrawn
  everyoneWith: product => `everyone with ${product}`, // the saved line on a recording that isn't a group's or an intake's

  // the 1-2-1 group and its reduced editor: the link and the notes (stage4-for-adam 14)
  clientGroup: (product, name) => `${product}, ${name}`,
  notes: 'Notes', // undrawn label; the placeholder is the 1-2-1 board's
  clientSavedChange: first => `Saved. ${first} sees the change now.`, // undrawn

  // Cohorts and dates
  datesLabel: 'Cohorts and their sessions',
  session: 'Session',
  states: { held: 'Held', setDate: 'Set a date', zoomSet: 'Zoom link set', noZoom: 'No Zoom link yet', cancelled: 'Cancelled' }, // the last 2 undrawn
  noDate: 'No date yet', // undrawn
  addCohort: n => `Add cohort ${n}`,
  // a new live course's first intake, or a new mastermind's first group (the product-types plan, 13 Oct)
  firstCohortLine: 'No intake yet. Add the first, with a session for each week, then set its dates.',
  addGroupCohort: name => `Add ${name}`, // a name that isn't "Cohort <n>", from the product's cohort_naming
  addSession: 'Add a session',
  added: 'Added. Set its dates',
  whatsapp: 'WhatsApp group invite link',
  whatsappAria: 'WhatsApp invite link',
  whatsappNote: "Members of this group join from the button on their product's Group page and from their welcome checklist. Change it here if you reset the link in WhatsApp.",
  whatsappSave: 'Save link', // undrawn
  whatsappSaved: group => `Saved. Members of ${group} join with the new link.`, // undrawn
  whatsappBad: 'A WhatsApp link starts with https://', // undrawn
  // Profit On Your Terms's deal surgery, switched on per intake (POYT.dc.html "Your deal surgery";
  // database builder 2's words, undrawn)
  surgery: 'Deal surgery for this intake',
  surgeryNote: 'Members of this intake see Your deal surgery and can ask for 30 minutes with you.',
  surgeryState: on => (on ? 'On' : 'Off'), // undrawn
  surgeryOn: cohort => `Switched on. Members of ${cohort} can ask for their deal surgery.`, // undrawn
  surgeryOff: cohort => `Switched off. Members of ${cohort} don't see Your deal surgery now.`, // undrawn
  // changed: the board's calendar line and its email go (Adam's answer 9; no date-change email, Adam, 5 Oct,
  // stage 6). Members see the new date on their pages; nothing is emailed
  footnote: "Move a date and members see the new date in the hub straight away. Nothing is emailed, so tell them yourself if it's soon.",
  pressHint: "Press a session that's been held to take its register, or one still to come to set its date and Zoom link.", // undrawn
  pressHintRegisters: "Press a session that's been held to take its register.", // undrawn: support and hosts
  noCohorts: 'There are no cohorts or groups with sessions in the hub yet.', // undrawn
  // a held row's register (the Accelerator critique's admin 7, 20 Oct, undrawn): how many are marked of the
  // register, for a session held in the last 14 days; only what's marked for an older 1, and Held for 1 with none
  registerOf: (marked, total) => `Register ${marked} of ${total}`,
  noRegisterYet: 'No register yet',
  markedOnly: n => `${n} marked`,
  // a mastermind group's later sessions with no Zoom link get the latest link typed for the group, in 1 write
  // (undrawn); the hub never reads Zoom
  zoomFillLabel: 'Zoom link for later sessions',
  zoomFill: "Use this Zoom link for the group's later sessions that have none",
  zoomFillNote: n => `${plural(n, 'later session')} ${n === 1 ? 'has' : 'have'} no Zoom link.`,
  zoomFillDone: (n, group) => `Saved. ${plural(n, 'later session')} of ${group} now ${n === 1 ? 'has' : 'have'} this Zoom link.`,
  openRegister: (label, date) => `${label}, ${date}: open its register`, // undrawn, for screen readers
  editSession: (label, date) => `${label}, ${date}: change its date and Zoom link`, // undrawn, for screen readers

  // the session box (undrawn: the board's rows can't be edited; the map's recommendation)
  sessionBox: (label, cohort) => `${label}, ${cohort}`,
  date: 'Date',
  timeUk: 'Time, UK',
  sessionLength: 'Length',
  zoomLink: 'Zoom link',
  zoomPlaceholder: 'https://zoom.us/...',
  save: 'Save',
  cancel: 'Cancel',
  sessionSaved: (label, when) => `Saved. ${label} is on ${when}.`,
  sessionSavedNoDate: label => `Saved. ${label} has no date yet.`,
  pickDateAndTime: 'Pick a date and a time, or neither.',
  zoomBad: 'A Zoom link starts with https://',

  // registers, under held sessions (undrawn: no board draws one; the critic's missed 1)
  registerCrumb: 'Cohorts and dates',
  registerTitle: (label, date) => `Register: ${label}, ${date}`,
  registerLede: 'Mark who came. It counts towards a certificate where a course needs live sessions.',
  registerLabel: 'Register',
  statuses: { present: 'Present', absent: 'Absent', excused: 'Excused' },
  // Excused's hint, in the 1 set of words every register uses (the Accelerator critique's admin 3, 20 Oct)
  statusHints: { excused: 'agreed in advance' },
  notExpected: 'Not in this intake',
  notExpectedGroup: 'Not in this group',
  testLogin: 'Test login',
  markedBy: (name, when) => `Marked by ${name}, ${when}`,
  // a line marked outside the hub, with nobody in the hub as its marker: the Accelerator's register lines copied from
  // the old members site (recorded_by null, so their undo can tell them from the hub's own). Changed (the review of
  // 11 Oct): it read "Marked by , <date>"
  markedWhen: when => `Marked ${when}`,
  notMarked: 'Not marked yet',
  noteAria: name => `Note for ${name}`,
  notePlaceholder: 'A note, only staff see it',
  saveNote: 'Save note',
  noteNeedsMark: 'Pick present, absent or excused first, then add a note.',
  registerEmpty: "Nobody had this product open at this session, so there's nobody to mark.",
  registerNotStarted: 'A register is taken once the session has started.',
  registerGone: "That session isn't there any more.",
  marked: (n, m) => `${n} of ${m} marked`,

  // Webinars. Changed for stage 6 (Adam, 5 Oct): the hub never connects to Zoom, so each webinar is added
  // and changed here by hand. Check Zoom now, "From Zoom", the registered and came-live counts and
  // their notes go; the hub's own count, the replay watched, stays.
  webinarStrip: "Schedule a webinar in Zoom, then add it here with its title, description, date, time, length and Zoom registration link. It stays off until you switch it on, then every account sees it. Members register on Zoom's own page, so Zoom emails them the link to join, and your Zoom workflow adds them to MailerLite as it does now.", // changed
  webinarList: 'Every webinar', // changed: the list's name for screen readers, without "from Zoom"
  comingUp: 'Coming up',
  replays: 'Replays',
  watched: n => `${n} watched`,
  notShown: 'Not shown',
  shownCount: 'Shown', // undrawn: in the list beside a webinar shown and still to come, for the board's "<n> registered"
  noWebinars: "There are no webinars in the hub yet. Add the next 1 you schedule in Zoom.", // undrawn
  addWebinar: 'Add a webinar', // undrawn: in the place of Check Zoom now
  addNote: 'Each webinar stays off until you switch it on.', // undrawn: under Add a webinar
  webinarStates: {
    shown: 'Shown, registrations open', hidden: 'Not shown yet', heldNoReplay: 'Held, no replay yet',
    replayUp: 'Replay up', replayDown: 'Replay taken down',
  },
  // the board's From Zoom box, now typed by hand (undrawn: its name and note)
  detailsBox: 'The webinar',
  detailsNote: 'Copy these from the webinar in Zoom. If it changes in Zoom, change it here too.',
  zoomRows: { title: 'Title', description: 'Description', date: 'Date', starts: 'Starts, UK time', length: 'Length', registration: 'Registration' },
  titlePlaceholder: "The webinar's title in Zoom", // undrawn
  descriptionPlaceholder: 'Its description in Zoom', // the board's sample, "[Its description in Zoom]"
  registrationPlaceholder: 'https://zoom.us/webinar/register/...', // undrawn
  registrationClosed: 'Closed, the webinar has run',
  noRegistration: 'No registration link yet', // undrawn
  titleNeeded: 'Give the webinar its title first.', // undrawn
  titleLong: 'A title can be up to 200 characters.', // undrawn
  descriptionLong: 'A description can be up to 2,000 characters.', // undrawn
  whenNeeded: 'Pick its date and its start time.', // undrawn
  // undrawn: only Zoom's own registration link is taken, as the database takes it (Adam, 5 Oct, stage 6's
  // batch, question 2), in the words of the replay link's own line
  registrationBad: "That isn't a Zoom link. Paste the webinar's registration link from Zoom.",
  // undrawn: under "Show it to every account", for 1 shown while still to come with no link (question 2)
  noRegistrationHint: "It has no registration link yet, so members can't register.",
  newEyebrow: 'New webinar', // undrawn
  newHeading: 'Add a webinar', // undrawn
  addIt: 'Add it', // undrawn, as Resources and files adds an item
  cancelAdd: 'Cancel', // undrawn
  showIt: 'Show it to every account',
  shownNote: 'Every account sees it in Free webinars and on the Library.',
  // changed: "Webinars from Zoom" for each webinar added here
  hiddenNote: 'Only you see it. Each webinar stays off until you switch it on, so nothing private shows by mistake.',
  sells: 'What it sells',
  nothing: 'Nothing',
  // changed: "once it's switched on", for the board's "once it is" (contractions)
  sellsNote: "Used only to hide the call to action on the replay from people who already have it. Everyone with an account sees the webinar once it's switched on.",
  ctaLabel: 'Call to action on the replay',
  ctaLabelPlaceholder: "The button's words",
  ctaUrl: 'Where it goes',
  ctaUrlPlaceholder: 'https://...',
  ctaText: 'Line above the button', // undrawn: webinars.cta_text, which Free webinars shows (stage3-for-adam 107)
  ctaTextPlaceholder: 'A sentence or 2 about what it offers', // undrawn
  ctaBoth: 'Give the call to action its words and where it goes, or leave both empty.', // undrawn
  ctaHttps: 'Where it goes has to start with https://', // undrawn
  replay: 'Replay, Vimeo link or embed code',
  replayPlaceholder: 'Paste it after the webinar',
  replayNone: 'After the webinar, paste the recording here. The replay stays up until you take it down.',
  replayUp: 'The replay is up. It stays until you take it down.',
  replayDown: 'The replay is down. Members no longer see it.',
  takeDown: 'Take the replay down',
  putBack: 'Put the replay back',
  replayChapters: 'Replay chapters, 1 a line', // undrawn: webinars.replay_chapters (stage3-for-adam 107)
  replayBad: "That isn't a Vimeo link. Paste the video's link from Vimeo, or its embed code.",
  // the hub's own count only (the board's Registered and Came live tiles were Zoom's)
  counts: { watchedReplay: 'Watched the replay', inHub: 'In the hub', onceUp: 'Once the replay is up', notYet: 'Not yet' },
  webinarSave: 'Save',
  webinarSaved: 'Saved. Members see the change now.',
  // undrawn: the saved line when the save switches it on while it's still to come, and the database
  // puts "New free webinar: <title>" in every account's bell. The bell is claimed only when the
  // database said it would ring (hub.bell_will_ring; never for 1 shown before), else the line without it
  webinarSavedShown: "Saved. Every account sees it now, and it's in their bell.",
  webinarSavedShownNoBell: 'Saved. Every account sees it now.', // undrawn
  webinarAddedShown: "Added. Every account sees it now, and it's in their bell.", // undrawn
  webinarAddedShownNoBell: 'Added. Every account sees it now.', // undrawn
  webinarAddedHidden: "Added. Members don't see it until you switch it on.", // undrawn
  webinarAddedReplay: "Added. Members see the replay while it's up.", // undrawn: 1 that has already run, shown
  webinarReadOnly: 'Only an owner or admin can change a webinar.', // undrawn

  // A webinar's own thumbnail (Adam, 9 Oct: "the webinars need to have like a professional thumbnail
  // which I can design myself"). Undrawn: no board has the block. The 3 buttons, the hint and the
  // warning are the words agreed with Adam; the rest are the build's
  thumbnail: 'Thumbnail',
  thumbnailAdd: 'Add a thumbnail',
  thumbnailChange: 'Change it',
  thumbnailOff: 'Take it off',
  thumbnailHint: 'Your own design, 16:9. 1280 by 720 pixels works best. A JPEG, PNG or WebP, up to 5 MB.',
  thumbnailCropped: "This isn't 16:9, so members see it cropped at the edges.",
  thumbnailNone: 'No thumbnail. Members see the date.', // the preview's line when there's none
  // a saved thumbnail that won't load, signed once more first (or that sign-file signs none for): the line
  // under the preview, and the preview's name for screen readers
  thumbnailBroken: "This thumbnail won't load, so members see the date. Change it or take it off.",
  thumbnailBrokenRead: "This thumbnail won't load, so members see the date.", // support's: no buttons to change it
  thumbnailPreview: 'The thumbnail, as members see it', // the preview's name for screen readers
  thumbnailReady: isNew => (isNew ? 'Ready. It goes on the webinar when you add it.' : 'Ready. It goes on the webinar when you save.'),
  thumbnailTakenOff: 'It comes off the webinar when you save.',
  thumbnailBadType: 'A thumbnail has to be a JPEG, PNG or WebP.',
  thumbnailTooBig: 'That image is bigger than 5 MB. Add a smaller one.',
  thumbnailUnreadable: "That image couldn't be read. Try saving it again as a JPEG or PNG.",
  thumbnailNotUploaded: "The thumbnail didn't upload. Try again.",
  // a course recording's own thumbnail (decision 47, 12 Oct), the same block as a webinar's
  recordingThumbnailReady: 'Ready. It goes on the recording when you save.',
  recordingThumbnailTakenOff: 'It comes off the recording when you save.',
  // Property Cashflow For Life's recordings (Adam, 12 Oct): with no thumbnail its cards keep the course's
  // own dark green module panel, not the date, so the preview draws that and its lines say so
  recordingThumbnailNoneModule: 'No thumbnail. Members see the module panel.',
  recordingThumbnailBrokenModule: "This thumbnail won't load, so members see the module panel. Change it or take it off.",
  recordingThumbnailBrokenReadModule: "This thumbnail won't load, so members see the module panel.", // support's

  // A replay's register page (docs/replay-register-spec.md 5, Adam's cut-down version of 23 Oct). Undrawn:
  // no board has it. The link, the name in MailerLite and the switch, saved with the webinar's Save
  rrPage: 'Register page',
  rrLede: "A page of its own for this replay, for an email or an ad. People type their first name and email and watch straight away. A new email gets a free account: free webinars and free resources only.",
  rrSlug: 'Link',
  rrSlugPlaceholder: '4-things-october',
  rrSlugPrefix: 'learn.adamslee.co.uk/register/',
  rrSlugHint: 'Lower-case letters and numbers, with a hyphen between words.',
  rrAddress: 'The full address',
  rrCopy: 'Copy',
  rrCopied: 'Copied',
  rrSource: 'Anything after ?src= is kept as the source, so you can tell which email or ad each person came from, like ?src=ml-oct-replay.',
  rrName: 'Name in MailerLite',
  rrNameHint: group => `Each person who registers goes into the MailerLite group ${group}.`,
  rrNameEmpty: 'Each person who registers goes into a MailerLite group with this name in it.',
  rrOn: 'Register page on',
  rrOnNote: 'Anyone with the link can register and watch the replay straight away.',
  rrOffNote: "While it's off, the link says the replay isn't available at the moment.",
  rrNotShown: "The webinar isn't shown to members, so the link says the replay isn't available until you switch Show it on.",
  rrNeedsSlug: 'Give the register page its link first.',
  rrNeedsName: 'Give it a name in MailerLite first.',
  rrNeedsReplay: "The replay has to be up before the register page can go on. Paste its Vimeo link and keep it up, then switch this on.",
  rrTakeOffFirst: 'Switch the register page off before you take the replay down or take its link away.',
  rrSlugBad: 'A link is 3 to 60 lower-case letters and numbers, with a hyphen between words, like 4-things-october.',
  rrNameBad: 'A name in MailerLite is 1 to 60 characters on 1 line.',
  rrSlugTaken: 'Another webinar already uses that link. Pick another.',
  rrRefused: "The register page couldn't be saved like that. Check its link and name, and that the replay is up.",
  rrList: n => `Registrations (${n})`,

  // The registrations list for 1 webinar (owner and admin: it shows emails)
  rrListTitle: 'Registrations',
  rrListBack: title => `Back to ${title}`,
  rrListCount: n => (n === 1 ? '1 person has registered.' : `${n} people have registered.`),
  rrListNone: 'Nobody has registered yet.',
  rrListCsv: 'Download CSV',
  rrListCsvDone: 'CSV downloaded',
  rrListHeads: { name: 'Name', email: 'Email', registered: 'Registered', source: 'Source', owns: 'Owns' },
  rrListTimes: (n, last) => `${n} times, last ${last}`,
  rrListNewAccount: 'New free account',
  rrListNoSource: 'None',
  rrListOwnsNothing: 'Nothing paid',
  rrListTest: 'Test',
  rrListOnlyOwnerAdmin: 'Only an owner or admin can see who registered.',
  rrListNoWebinar: "That webinar isn't in the hub.",
  rrListNoLink: "This webinar has no register page yet. Give it a link on the webinar's page.",
  rrListCsvName: slug => `registrations-${slug || 'replay'}`,
  // The property strategy tool's completions (Stage 2, docs/property-strategy-spec.md S2.9). Undrawn: words for Adam.
  stLink: 'Property strategy tool completions',
  stCrumb: 'Property strategy tool',
  stTitle: 'Property strategy tool completions',
  stOnlyOwnerAdmin: 'Only the owner and admins can see this list.',
  // completions, not people: someone who completes the tool twice is 2 rows
  stCount: n => (n === 1 ? '1 completion.' : `${n} completions.`),
  stFull: 'Showing the newest 1,000.',
  stNone: 'Nobody has completed the tool yet.',
  stCsv: 'Download CSV',
  stCsvDone: 'CSV downloaded',
  stHeads: { name: 'Name', email: 'Email', completed: 'Completed', source: 'Source', strategy: 'Strategy', sent: 'Sent' },
  stNewAccount: 'New free account',
  stNoSource: 'None',
  stTest: 'Test',
  stNoName: 'No name given',
  stCsvName: 'strategy-tool-completions',
  rrOwnsStatus: { secured: 'place secured', active: 'active', overdue: 'overdue', suspended: 'suspended', paused: 'paused', ended: 'ended' },

  // shared
  loadFailed: "That didn't load. Check your connection and try again.",
}

export { plural }
